import React, { forwardRef, MutableRefObject } from 'react';
import { Checkbox, ICheckboxProps } from 'native-base';
import { useTheme } from '@springbig/shared';

export const CheckBoxWrapper = forwardRef(
    ({
        isChecked,
        value,
        isDisabled,
        onChange,
        ...props
    }: ICheckboxProps , ref: MutableRefObject<HTMLDivElement>) => {

        const {
            primary,
            field_background,
            field_color,
            field_border,
            radius_sm,
        } = useTheme();

        return (
            <Checkbox
                isChecked={isChecked}
                value={value}
                isDisabled={isDisabled}
                onChange={onChange}
                bg={field_background}
                borderColor={field_border}
                rounded={Math.min(radius_sm, 5) || 0} // prevents checkboxes from looking like radios
                _icon={{ color: primary }}
                _checked={{
                    value: '',
                    bg: field_background,
                    color: field_color,
                    borderColor: field_border,
                }}
                ref={ref}
                {...props}
            />
        );
    });

CheckBoxWrapper.displayName = 'CheckBoxWrapper';

export default CheckBoxWrapper;
